export type CheckoutSection = 'email' | 'gift' | 'giftCards' | 'address' | 'billing' | 'shipping';

interface CheckoutReadiness {
  emailComplete: boolean;
  /** true when the order is not a gift */
  giftValid: boolean;
  giftCardsValid: boolean;
  addressComplete: boolean;
  /** true unless a ship-to-recipient gift still needs the buyer's billing address */
  billingComplete: boolean;
  hasShippingCode: boolean;
}

/** wallet rows and the submit button both wait on this, in form order, so neither skips the gift options */
export function firstIncompleteSection({
  emailComplete,
  giftValid,
  giftCardsValid,
  addressComplete,
  billingComplete,
  hasShippingCode,
}: CheckoutReadiness): CheckoutSection | undefined {
  if (!emailComplete) return 'email';
  if (!giftValid) return 'gift';
  if (!giftCardsValid) return 'giftCards';
  if (!billingComplete) return 'billing';
  if (!addressComplete) return 'address';
  if (!hasShippingCode) return 'shipping';
  return undefined;
}
